import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from '../Icon';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'flex-start'
    }
});

class Rating extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.stars = [];

        for (let i = 0; i < 5; i++) {
            this.stars.push(
                // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
                // eslint-disable-next-line react/prop-types
                <Icon
                    key={i}
                    name={i < props.value ? 'star' : 'star_off'}
                    style={{ width: 17, height: 17 }}
                />
            );
        }
    }

    render() {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { style } = this.props;
        return <View style={[styles.container, style]}>{this.stars}</View>;
    }
}

export default Rating;
